<template>
  <div>
    <div>
      <v-img
        size="60"
        :src="profilePic"
        style="border-radius: 10%"
        @click="openImageDialog()"
      ></v-img>
      <input
        type="file"
        id="files"
        ref="fileInput"
        :style="{ display: display }"
        accept="image/*"
        @change="getSelectedImage"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    profilePicture: {
      default: true,
    },
    imageName: {
      default: "picture",
    },
    imageFolder: {
      default: "",
    },
    display: {
      default: "inline",
    },
    imagePath: {
      default: null,
    },
  },
  mounted() {
    if (this.imagePath) {
      this.profilePic = this.imagePath;
    }
  },
  data: () => ({
    profilePic: "/images/products/no-photo.jpg",
    selectedImageName: "",
  }),
  methods: {
    openImageDialog() {
      document.getElementById("files").click();
    },
    getSelectedImage(event) {
      const file = event.target.files[0];
      const ext = file.type.split("/")[1];
      this.selectedImageName = this.imageName + "." + ext;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        console.log(fileReader.result);
        this.$emit("logo-loaded", fileReader.result);
      });
      fileReader.readAsDataURL(file);
    },
  },
};
</script>
